import { grpc, someGrpc } from "@somewear/grpc";
import { actionSetEpicHandlerBuilder } from "@somewear/model";
import { combineEpics } from "redux-observable";

import { workspacePreferencesActions } from "./workspacePreferences.actions";

const updateWorkspacePreferencesEpic = actionSetEpicHandlerBuilder(
	workspacePreferencesActions.updateWorkspacePreferences,
	(payload) => grpc.prepareRequestWithPayload(someGrpc.updateWorkspacePreferences, payload.data),
	() => {
		return {
			onFulfilled: "Successfully updated Workspace Advanced Settings",
			onPending: "",
			onRejected: "Failed to update Workspace Advanced Settings",
		};
	},
);

export const workspacePreferencesEpics = combineEpics<any, any, any>(
	updateWorkspacePreferencesEpic,
);
